import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import {
    IPPVPurchasePinPayload,
    IPPVPurchasePinResponse,
    IPPVPurchaseVerifyOtpPayload,
    IPPVPurchaseVerifyOtpResponse,
} from '../../../entity/interface/iEntitlements';
import { use } from 'react';

export interface IPPVPurchasePinUseCase {
    execute(
        payload: IPPVPurchasePinPayload,
        username: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string },
        apiKey: string
    ): Promise<IPPVPurchasePinResponse>;
}

export class PPVPurchasePinUseCase implements IPPVPurchasePinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get PPVPurchasePinRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IPPVPurchasePinPayload,
        username: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string },
        apiKey: string
    ): Promise<IPPVPurchasePinResponse> {
        const response = await this.PPVPurchasePinRepository.ppvPurchasePin(
            payload,
            username,
            authToken,
            authSign,
            identityToken,
            csrfToken,
            apiKey
        );
        return response;
    }
}
